import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import { useAppContext } from '@groupefungo/react-apollo.core/app/UseContext/useAppContext';
import Modal from './Modal';
import useAppointmentGql from '../appointments/hooks/useAppointmentGql';

function TimeLimitReachedModal(props) {
  const { confirmationLabel, gid } = props;

  const { Button, Typography, makeStyles } = useUiContext();
  const { useHistory } = useAppContext();
  const history = useHistory();

  const useStyles = makeStyles((theme) => ({
    root: {
      height: 300,
      flexGrow: 1,
      minWidth: 300,
      transform: 'translateZ(0)',
      // The position fixed scoping doesn't work in IE 11.
      // Disable this demo to preserve the others.
      '@media all and (-ms-high-contrast: none)': {
        display: 'none',
      },
    },
    modal: {
      display: 'flex',
      // padding: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      margin: 'auto',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));

  const classes = useStyles();

  const handleOnConfirm = () => {
    history.push(`${process.env.PROXY_PATH}/booking/appointment/${history.location.pathname.split('/')[5]}/availabilities`);
  };

  return (
    <div>
      <Modal
        className={classes.modal}
        open
        disablePortal
        disableEnforceFocus
        disableAutoFocus
      >
        <div className={classes.paper}>

          <div>
            <Typography variant="h6">{confirmationLabel}</Typography>
          </div>

          <div>
            <Button onClick={handleOnConfirm}>Understood</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

TimeLimitReachedModal.propTypes = {
  confirmationLabel: PropTypes.string.isRequired,
};

export default TimeLimitReachedModal;
